import { BASE_URL } from "./config";
import {toast} from "react-toastify";

export default async function apiRequest(services, link, method, form, token, dispatch, navigate) {
  const url = BASE_URL[services] + link;
  console.log("url", url);

  let headers = {
    Accept: "application/json",
  };

  let body = form instanceof FormData ? form : JSON.stringify(form);

  if (!(form instanceof FormData)) {
    headers["Content-Type"] = "application/json;charset=UTF-8";
  }

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  console.log("token:", token);
  console.log("body:", body);

  try {
    const response = await fetch(url, {
      method: method,
      headers: headers,
      body: method !== "GET" && method !== "HEAD" ? body : undefined,
      mode: "cors",
    });

    if(response.status === 401) {
      // Handle unauthorized access
      const errorData = await response.json();
      console.error("Error response:", {errorData});
      toast.warn(errorData.message || "Unauthorized access. Please log in again.");
      dispatch({
        type: "USER",
        value: null,
      });
      dispatch({
        type: "LOGOUT",
        value: {},
      });
      console.log("Logout");
      navigate("/");
      return ApiResponse(errorData.status, { ...errorData });
    }
    const data = await response.json();
    return ApiResponse(response.status, data);
  } catch (error) {
    console.error("Error:", error);
    return ApiResponse(500, { ...error });
  }
}

function ApiResponse(status, data) {
  return {
    status: status,
    body: data,
  };
}
